import { render, staticRenderFns } from "./SearchResultEntry.vue?vue&type=template&id=949bf372"
import script from "./SearchResultEntry.vue?vue&type=script&lang=ts"
export * from "./SearchResultEntry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/skade-pwa/components/ui/atom/Img.vue').default,Truncate: require('/skade-pwa/components/ui/atom/Truncate.vue').default})
